import * as React from "react";

interface IProps {
    elementName: string,
    valid: boolean,
    disable: boolean,
    onSelectFile: (file: File) => void,
}
class UploadFile extends React.Component<IProps, {}> {
    fileInput: any;

    constructor(props: IProps) {
        super(props);

        this.fileInput = React.createRef();
    }

    handleFileChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onSelectFile(e.currentTarget.files[0]);
    }

    getFileName = () => {
        let fileName = "";

        if (this.fileInput.current != null) {
            if (this.fileInput.current.files != null) {
                if (this.fileInput.current.files.length > 0) {
                    fileName = this.fileInput.current.files[0].name;
                }
            }
        }

        return fileName;
    }

    render = () => {
        const file = this.getFileName();

        return (
            <>
                {!this.props.disable && (
                    <>
                        <input type="file" id={this.props.elementName} ref={this.fileInput} style={{ opacity: 0, position: "absolute", pointerEvents: "none", width: 1, height: 1 }} onChange={this.handleFileChange} />
                        <label className="btn btn-primary btn-xs" style={{ borderWidth: this.props.valid ? 1 : 2, borderColor: this.props.valid ? "#2e6da4" : "red" }} htmlFor={this.props.elementName}>Select File</label>
                        {/* <span style={{ marginLeft: 10 }}>{file ? 'File to upload: ' + file : ''}</span> */}
                    </>
                )}
            </>
        );
    }
}

export default UploadFile;